import { onMounted, defineComponent, ref, provide, reactive, toRefs, getCurrentInstance, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Header2 from '@/components/layout/header2.vue';
import Footer from '@/components/layout/footer.vue';
import Menu from '@/components/layout/menu.vue';
import SideMenu from '@/components/layout/SideMenu.vue';
import SideComponent from '@/components/common/SideComponent.vue';
import PhoneVerifyForm from '@/components/common/PhoneVerifyForm.vue';
import { NOTICE_LIST_PATH, maskMobile, isBoundMobile } from '@/utils/phoneVerify';

export default defineComponent({
	components: {
		Header2,
		Menu,
		Footer,
		SideMenu,
		SideComponent,
		PhoneVerifyForm,
	},
	setup() {
		const { proxy } = getCurrentInstance();
		const store = useStore();
		const router = useRouter();
		const data = reactive({
			showHeader: true,
			loginStyle: 'min-width:141px;',
			mobileIconStyle: 'color:rgba(223, 58, 8, 1);',
			showListIcon: true,
		});
		const showMenu = ref(proxy.$menus);
		provide('showMenu', showMenu);
		const outerStyleStr = ref("position:relative;left:10%;top:40%;transform:translate(-10%,-40%);width:auto;");
		provide('outerStyleStr', outerStyleStr);
		const styleStr = ref("height:45px;");
		provide('styleStr', styleStr);
		const showSearchText = ref(false);
		provide('showSearchText', showSearchText);

		const maskedMobile = computed(() => {
			return store.state.user.phoneVerifyMaskedMobile ||
				maskMobile(store.state.user.personProfile.mobile || store.state.user.userInfo.mobile || '');
		});
		const hasMobile = computed(() => {
			return !!store.state.user.phoneVerifyHasMobile ||
				isBoundMobile(store.state.user.personProfile.mobile || store.state.user.userInfo.mobile);
		});

		const viewBox = ref(null);
		const scroll = (val) => {
			if (val == 'top') {
				viewBox.value.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
			}
		};

		const goNotice = () => {
			router.push(NOTICE_LIST_PATH);
		};

		const onVerified = () => {
			if (window.history.length > 1) {
				router.back();
			} else {
				router.push('/');
			}
		};

		onMounted(() => {
			store.dispatch('user/getPersonInfo', {}).catch(() => {});
		});

		return {
			...toRefs(data),
			maskedMobile,
			hasMobile,
			viewBox,
			scroll,
			goNotice,
			onVerified,
		};
	},
});
